<template>
    <v-container>
            <v-row class=" d-flex justify-space-between">
                    <div class="text-h4 mb-5 mt-5">Registros</div>
            </v-row>
            <v-card :loading="loading">
                <v-card-title>
                    <v-text-field
                        v-model="buscar"
                        append-icon="mdi-file-search-outline"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="registros" :search="buscar" :sort-by="['created_at']" :sort-desc="[true]">
                    <template v-slot:item.estado="{ item }">
                        <v-chip
                            :color="item.estado.color"
                            outlined
                            pill
                            small
                        >
                            {{ item.estado.estado }}
                        </v-chip>
                    </template>
                    <template 
                        v-slot:item.acciones="{ item }"
                    >
                        <v-icon
                            v-if="item.estado.estado === 'Pendiente'"
                            class="mr-2"
                            @click="editar(item)"
                        >
                            mdi-file-document-edit-outline
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card>
        <v-btn fab dark color="teal lighten-1" @click="abrirDialog()" fixed style="bottom: 37px; right: 30px;">
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        
        <v-dialog v-model="dialogImportarFacturas" max-width="500px" persistent>
            <v-card>
                <v-card-title>Importar facturas</v-card-title>
                <v-card-text>
                    <v-autocomplete
                        :items="empresas.empresas"
                        item-value="CodigoEmpresa"
                        item-text="Empresa"
                        label="Empresa"
                        prepend-icon="mdi-domain"
                        :loading="empresas.loadingEmpresas"
                        v-model="empresaSeleccionada"
                    ></v-autocomplete>
                    <v-file-input
                        accept="text/csv"
                        label="Selecciona archivo CSV"
                        v-model="archivoCSV"
                        :disabled="procesandoFacturas || editando"
                    ></v-file-input>
                </v-card-text>
                <v-card-actions>
                    <v-btn 
                        v-if="editando"
                        text 
                        @click="avisoEliminar = true"
                        color="error"
                    >Eliminar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn 
                        text 
                        @click="cerrarDilog()"
                        :disabled="procesandoFacturas"
                    >Cancelar</v-btn>
                    <v-btn 
                        color="blue darken-1" 
                        text 
                        @click="procesarFacturas()"
                        :disabled="this.$v.$invalid"
                        :loading="procesandoFacturas"
                    >Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="avisoEliminar" max-width="500px" persistent>
            <v-card>
                <v-card-title>¡Atención!</v-card-title>
                <v-card-text>
                    ¿Confirmas que quieres eliminar el registro?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                        text 
                        @click="avisoEliminar = false"
                    >Cancelar</v-btn>
                    <v-btn 
                        text 
                        @click="eliminar()"
                        color="error"
                        :loading="procesandoBorradoFactura"
                    >Confirmar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import axios from 'axios';
    axios.defaults.withCredentials = true;
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    export default {
        name: 'Registros',
        data: () => ({
            archivoCSV: null,
            fab: false,
            transition: 'slide-y-reverse-transition',
            registros: [],
            buscar: '',
            headers: [
                {
                    text: 'Fichero',
                    align: 'start',
                    filterable: true,
                    sortable: true,
                    value: 'fichero'
                },
                {
                    text: 'Fecha importación',
                    align: 'start',
                    filterable: true,
                    sortable: true,
                    value: 'created_at'
                },
                {
                    text: 'Empresa',
                    align: 'start',
                    filterable: true,
                    sortable: true,
                    value: 'empresa.Empresa'
                },
                {
                    text: 'Nº facturas',
                    align: 'start',
                    filterable: true,
                    sortable: true,
                    value: 'facturas_count'
                },
                {
                    text: 'Estado',
                    filterable: true,
                    sortable: true,
                    value: 'estado',
                },
                {
                    text: '',
                    filterable: false,
                    sortable: false,
                    value: 'acciones'
                }
            ],
            loading: false,
            empresaSeleccionada: null,
            procesandoFacturas: false,
            procesandoBorradoFactura: false,
            dialogImportarFacturas: false,
            registroIdSeleccionado: null,
            avisoEliminar: false
        }),
        validations: {
            archivoCSV: { required },
            empresaSeleccionada: { required }
        },
        methods: {
            ...mapActions(['setSnackbar', 'setEmpresas']),
            
            listarRegistros(){
                this.loading = true;
                axios.get("/api/registros").then(respuesta => {
                    this.loading = false;
                    this.registros = respuesta.data;
                }).catch(error =>{
                    this.loading = false;
                    this.setSnackbar({
                        snackbar: true,
                        tipo: 'error',
                        mensaje: 'No se han podido recuperar los registros'
                    });
                });
            },
            abrirDialog(){
                if (!this.empresas.empresas.length) {
                    this.setEmpresas();
                }
                // console.log(this.empresas);
                this.dialogImportarFacturas = true;
            },
            cerrarDilog(){
                this.dialogImportarFacturas = false;
                this.archivoCSV = null;
                this.empresaSeleccionada = null;
                this.$v.$reset();
                this.registroIdSeleccionado = null;
            },
            editar(registro){
                this.registroIdSeleccionado = registro.id;
                this.empresaSeleccionada = registro.empresa.CodigoEmpresa;
                this.archivoCSV = new File([registro.fichero], registro.fichero, {
                  type: "text/csv",
                });
                this.abrirDialog();
            },
            eliminar(){
                this.procesandoBorradoFactura = true;
                axios.delete(`/api/importar-facturas/${this.registroIdSeleccionado}`).then(respuesta => {
                    this.listarRegistros();
                    this.setSnackbar({
                        snackbar: true,
                        tipo: 'success',
                        mensaje: 'Registro eliminado correctamente'
                    });
                }).catch(error =>{
                    if(error.response.status === 400){
                        this.setSnackbar({
                            snackbar: true,
                            tipo: 'warning',
                            mensaje: error.response.data.message
                        });
                    }else{
                        this.setSnackbar({
                            snackbar: true,
                            tipo: 'error',
                            mensaje: 'Error. No se ha podido eliminar el registro.'
                        });
                    }
                }).finally(() => {
                    this.avisoEliminar = false;
                    this.procesandoBorradoFactura = false;
                    this.cerrarDilog();
                });
            },
            procesarFacturas(){
                this.procesandoFacturas = true;
                let formData = new FormData();
                formData.append("CodigoEmpresa", this.empresaSeleccionada);
                if(this.editando){ // Editando registro
                    formData.append("_method", 'PATCH'); // workaround problema patch con formData
                    axios.post(`/api/importar-facturas/${this.registroIdSeleccionado}`, formData).then(respuesta => {
                        this.listarRegistros();
                        this.setSnackbar({
                            snackbar: true,
                            tipo: 'success',
                            mensaje: 'Datos actualizados correctamente.'
                        });
                    }).catch(error =>{
                        if(error.response.status === 400){
                            this.setSnackbar({
                                snackbar: true,
                                tipo: 'warning',
                                mensaje: error.response.data.message
                            });
                        }else{
                            this.setSnackbar({
                                snackbar: true,
                                tipo: 'error',
                                mensaje: 'Error. No se ha podido actualizar el registro.'
                            });
                        }
                    }).finally(() => {
                        this.procesandoFacturas = false;
                        this.cerrarDilog();
                    });
                }else{
                    formData.append("CSVfile", this.archivoCSV);
                    axios.post("/api/importar-facturas", formData).then(respuesta => {
                        this.listarRegistros();
                        this.setSnackbar({
                            snackbar: true,
                            tipo: 'success',
                            mensaje: 'Datos importados correctamente.'
                        });
                    }).catch(error =>{
                        if(error.response.status === 400){
                            this.setSnackbar({
                                snackbar: true,
                                tipo: 'warning',
                                mensaje: error.response.data.message
                            });
                        }else{
                            this.setSnackbar({
                                snackbar: true,
                                tipo: 'error',
                                mensaje: 'Error. No se han podido procesar las facturas.'
                            });
                        }
                    }).finally(() => {
                        this.procesandoFacturas = false;
                        this.cerrarDilog();
                    });
                }
            },
        },
        mounted() {
            this.listarRegistros();
        },
        computed: {
            ...mapState(['empresas', 'loadingEmpresas']),
            editando(){
                return this.registroIdSeleccionado != null;
            }
        }
    }
</script>